var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-english"},[_c('web-header',{ref:"webHeaderRef",attrs:{"language":"en"}}),_c('div',{staticClass:"activity-english-wrap"},[_vm._v(" Waiting for development ")]),_c('web-footer',{attrs:{"language":"cn"}}),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }